import { Injectable } from "@angular/core";
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from "rxjs/Observable";
import { Observer } from "rxjs/Observer";
import { Store, Action } from "@ngrx/store";
import { AppState } from "@store/app-state";
import { Event } from "@models/event";
import { EventEffects } from "@reducers/effects/event";
import { UserEffects } from "@reducers/effects/user";
import {
  FETCH_EVENTS,
  POPULATE_EVENTS,
  FETCH_EVENT,
  POPULATE_ACTIVE_EVENT
} from "@reducers/events";
import {
  FETCH_CURRENT_USER_CONTACT,
  POPULATE_CURRENT_USER_CONTACT
} from "@reducers/user";
import { Angular2TokenService } from 'angular2-token';
import { User } from "@models/user";

@Injectable()
export class EventViewResolver implements Resolve<boolean> {

  constructor(
    private store: Store<AppState>,
    private eventEffects: EventEffects,
    private userEffects: UserEffects,
    private router: Router,
    private tokenService: Angular2TokenService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    if (!route.params.id) { this.router.navigate(["events"]) }

    this.store.dispatch({ type: FETCH_EVENTS })
    this.store.dispatch({ type: FETCH_EVENT, payload: route.params.id })

    const event = this.eventEffects.fetch
      .take(1)
      .filter((a: Action) => a.type == POPULATE_ACTIVE_EVENT)
      .map(() => true)

    const user = this.tokenService.validateToken()
      .take(1)
      .switchMap(
        (res: any) => {
          const user = User.initFromCurrentUserData(this.tokenService.currentUserData)
          return Observable.of(true)
      })
      .catch((err: any) => {
        return Observable.of(true)
      })

      return Observable.zip(event, user).take(1).map(() => true)
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/resolvers/event-view.ts